import * as React from 'react';
import ReactDOM from 'react-dom';

import {CalendarPage} from './calendar-page';

export function PortalledCalendarSettings() {
    const calendarSettingsContainer = document.querySelector('#react-mount-calendar-page');
    if (calendarSettingsContainer) {
        return ReactDOM.createPortal(<CalendarPage />, calendarSettingsContainer);
    }

    return null;
}
